import { Grid, Paper, Typography } from "@material-ui/core";
import { FC } from "react";
import ReactHTMLParser from 'react-html-parser';

import PoolDetailStyle from "./DetailsStyle";

type AllowedContentType = 'image' | 'video' | 'text' | 'html';

type DynamicSectionProps = {
    header: string,
    content: string,
    poolData: any,
}

const DynamicSection: FC<any> = ({ content, poolData }: DynamicSectionProps) => {
    
    const classes = PoolDetailStyle();

    return (
        <Grid
            container
            direction="column"
        >
            {/* <Grid
                item
            >
                <Typography className={classes.sectionHeader}>
                    { header }
                </Typography>
            </Grid> */}
            <Grid
                item
                className={classes.content}
            >
                {
                    ReactHTMLParser(content)
                }
            </Grid>
        </Grid>
    )
}

export default DynamicSection;